import React, {useState, useEffect} from 'react';
import {truncate, isEmpty} from 'lodash';

import Link from './Link';
import {getMultipleQuestions} from '../api/api';
import {useAnalytics} from '../hooks';

const MAX_TITLE_LENGTH = 200;

const QuestionItem = ({
  question, trackerEvent, slug, source,
}) => {
  let displayText = '';
  if (question.comments > 1) {
    displayText = `View ${question.comments} answers ->`;
  } else {
    displayText = 'See question ->'; // use this for 0-1 comments
  }

  const url = `/questions/${question.id}/${question.slug}`;

  const handleClick = () => {
    trackerEvent?.({question: question.id, slug, source});
  };

  return (
    <Link
      href={url}
      target="_blank"
      onClick={handleClick}
      className="no-underline cursor-pointer py-3 px-4 mb-2 border border-gray-200 rounded-lg text-gray-700 text-sm font-semibold leading-none hover:border-gray-300 transition duration-50 flex justify-between items-center"
    >
      <div>
        <div className="inline text-base">
          {truncate(question.data.title, {length: MAX_TITLE_LENGTH})}
        </div>
      </div>

      <div className="text-indigo ml-4 flex items-center gap-x-0.5 whitespace-nowrap hidden md:block">
        {displayText}
      </div>

      <div className="text-indigo ml-2 flex items-center gap-x-0.5 whitespace-nowrap md:hidden">
        {'->'}
      </div>
    </Link>
  );
};

const QuestionWidget = ({
  title, questions: q, source = 'lesson', slug,
}) => {
  // TODO: Add filter support
  const {tracker} = useAnalytics();

  const [questions, setQuestions] = useState([]);

  useEffect(() => {
    const getAndSetQuestions = async () => {
      if (!Array.isArray(q)) return;

      const res = await getMultipleQuestions(q);
      setQuestions(res);
    };

    if (q && isEmpty(questions)) getAndSetQuestions();
  }, []);

  if (isEmpty(questions)) return null;

  return (
    <div>
      <div className="mb-2 font-semibold">{title}</div>
      {questions.map((question, i) => (
        <QuestionItem
          question={question}
          trackerEvent={tracker.questionWidgetClickQuestion}
          slug={slug}
          source={source}
        />
      ))}
    </div>
  );
};

export default QuestionWidget;
